<script setup lang="ts">
import { useI18n } from "petite-vue-i18n";

import ErrorIcon from "@/assets/icons/error.svg";

const { t } = useI18n();

withDefaults(
  defineProps<{
    heading?: string;
    subheading?: string;
    infoText?: string;
    errorCode?: string;
  }>(),
  {
    heading: "",
    subheading: "",
    infoText: "",
    errorCode: "",
  }
);
</script>

<template>
  <div class="mb-8">
    <img :src="ErrorIcon" alt="Error" class="size-20" />
  </div>

  <h6 v-if="errorCode" class="dark:text-app-500 mb-4 text-xl font-bold capitalize text-app-red-600 sm:text-2xl">{{ t(errorCode) }}</h6>

  <h4 v-if="heading" class="mb-4 px-6 text-xl font-bold text-app-gray-900 dark:text-app-white sm:text-2xl md:text-4xl">{{ t(heading) }}</h4>
  <h4 v-else class="mb-4 px-8 text-xl font-bold text-app-gray-900 dark:text-app-white sm:text-2xl md:text-4xl">
    {{ t("passwordless.error-something-wrong-error") }}
  </h4>

  <h6 v-if="subheading" class="mb-4 px-4 text-base font-normal text-app-gray-500 dark:text-app-gray-400 sm:md:text-lg">{{ t(subheading) }}</h6>
  <h6 v-else class="mb-4 px-8 text-base font-normal text-app-gray-500 dark:text-app-gray-400 sm:text-lg">
    {{ t("passwordless.something-went-wrong-subheading") }}
  </h6>

  <h6 v-if="infoText" class="px-8 text-base text-app-gray-500 dark:text-app-gray-300">{{ t(infoText) }}</h6>
</template>
